export default __webpack_public_path__ + "static/media/info1.dd6fd27c.svg";